<template>
  <v-data-iterator
    :items="rooms.data"
    :page.sync="page"
    :items-per-page.sync="size"
    :server-items-length="rooms.meta.pagination.total"
    :footer-props="{ itemsPerPageOptions }"
  >
    <template v-slot:default="slot">
      <im-room-card v-for="(room, index) in slot.items"
        :room="room"
        :key="index"
        @edit="$emit('edit', room)"
      />
    </template>
  </v-data-iterator>
</template>


<script>

  export default {

    components: {
      'im-room-card': () => import('@/components/Room/RoomCard')
    },

    props: {
      rooms: Object
    },

    data: () => ({
      page: 1,
      size: 10,
      itemsPerPageOptions: [10, 15, 30, 50]
    }),

    watch: {
      page: {
        handler () {
          this.$emit('list', {
            size: this.size,
            page: this.page
          })
        },
        immediate: false,
        deep: true
      },
      size: {
        handler () {
          this.$emit('list', {
            size: this.size,
            page: this.page})
        },
        immediate: false,
        deep: true
      },
    },
  }

</script>